var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubjectTution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2501 12.4751V15.9876C4.2501 16.9001 4.7501 17.7501 5.5501 18.1876L11.8001 21.6001C12.5501 22.0126 13.4501 22.0126 14.2001 21.6001L20.4501 18.1876C21.2501 17.7501 21.7501 16.9001 21.7501 15.9876V12.4751L14.2001 16.6001C13.4501 17.0126 12.5501 17.0126 11.8001 16.6001L4.2501 12.4751ZM11.8001 0.400098L1.2626 6.1501C0.400098 6.6251 0.400098 7.8751 1.2626 8.3501L11.8001 14.1001C12.5501 14.5126 13.4501 14.5126 14.2001 14.1001L24.2501 8.6126V16.0001C24.2501 16.6876 24.8126 17.2501 25.5001 17.2501C26.1876 17.2501 26.7501 16.6876 26.7501 16.0001V7.9876C26.7501 7.5251 26.5001 7.1126 26.1001 6.8876L14.2001 0.400098C13.4501 9.76622e-05 12.5501 9.76622e-05 11.8001 0.400098Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubjectTution);
export default __webpack_public_path__ + "static/media/subject_tution.5ec93864e95ee394e7db73cbf5f1de3e.svg";
export { ForwardRef as ReactComponent };